var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMegaphone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "rgba(21,27,38,.75)",
    viewBox: "0 0 24 24",
    title: "megaphone",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MultiColorIcon-path--fadedBlack",
    d: "M22,3v19h-3V3H22z M2,7v10h9V7H2z M4,10.5C4,10.2,4.2,10,4.5,10h4C8.8,10,9,10.2,9,10.5S8.8,11,8.5,11h-4 C4.2,11,4,10.8,4,10.5z M4.5,13C4.2,13,4,13.2,4,13.5S4.2,14,4.5,14h4C8.8,14,9,13.8,9,13.5S8.8,13,8.5,13H4.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    className: "MultiColorIcon-path--white",
    d: "M7.9,17l2.1,5H6l-2-5H7.9z M11,7.6v9l8,4.4V4L11,7.6z M24,12c0,0.8-0.3,1.6-0.9,2.1c-0.3,0.3-0.7,0.6-1.1,0.7 V9.2C23.2,9.6,24,10.7,24,12z M2,10c-1.1,0-2,0.9-2,2s0.9,2,2,2V10z M9,10.5C9,10.2,8.8,10,8.5,10h-4C4.2,10,4,10.2,4,10.5 S4.2,11,4.5,11h4C8.8,11,9,10.8,9,10.5z M9,13.5C9,13.2,8.8,13,8.5,13h-4C4.2,13,4,13.2,4,13.5S4.2,14,4.5,14h4 C8.8,14,9,13.8,9,13.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/megaphone.ebc196a8.svg";
export { ForwardRef as ReactComponent };